export default __webpack_public_path__ + "static/media/GiveawayMobile.36a7e26c.mp4";